// Design tokens for "Day spine v2" (design handoff option 7a) — a light, single-theme
// screen distinct from both prior redesigns this app has had (holo dial / arc console).
// Kept as literal values (not var(--*) globals) since nothing else in the app uses this
// exact palette; matches the handoff's own instruction that colors are "final."

export const FONT_UI   = "'Archivo', Helvetica, sans-serif";
export const FONT_MONO = "'IBM Plex Mono', monospace";

export const C = {
  page: '#f6f7fb',
  surface: '#ffffff',
  ink: '#1b2540',
  ink70: 'rgba(27,37,64,.82)',
  ink60: 'rgba(27,37,64,.6)',
  ink50: 'rgba(27,37,64,.5)',
  ink45: 'rgba(27,37,64,.45)',
  ink42: 'rgba(27,37,64,.42)',
  ink40: 'rgba(27,37,64,.4)',
  hairline06: 'rgba(27,37,64,.06)',
  hairline08: 'rgba(27,37,64,.08)',
  hairline10: 'rgba(27,37,64,.10)',
  hairline18: 'rgba(27,37,64,.18)',

  blue: '#3f6cf5',
  blueInk: '#2b4fbd',
  blueTint: 'rgba(63,108,245,.1)',
  blueBorder: 'rgba(63,108,245,.2)',
  blueBorderStrong: 'rgba(63,108,245,.22)',

  plum: '#6a5bd6',
  plumInk: '#4c3fa8',
  plumTint: 'rgba(106,91,214,.1)',

  orange: '#f5a300',
  orangeInk: '#c47500',
  orangeTint: 'rgba(245,163,0,.1)',
  orangeCard: '#fff6e6',
  orangeCardBorder: 'rgba(245,163,0,.3)',
  leagueBg: 'linear-gradient(120deg,#fff6e2,#fff)',
  leagueBorder: 'rgba(245,163,0,.28)',

  redOrange: '#e2622f',
  redInk: '#c2481a',
  redTint: 'rgba(226,98,47,.1)',
  // A more saturated, less orange red specifically for the "under target" zone chips —
  // redOrange above stays as-is for the MATCH tag / RPE 9-10, which weren't part of the ask.
  redStrong: '#dc2626',

  green: '#1d9e6b',

  teal: '#2aa79a',
  tealTint: '#e9f7f4',
  tealBtn: '#d8efea',
  tealBorder: 'rgba(42,167,154,.25)',

  wellnessCard: '#eef2ff',
};

// getStatus() (src/pages/GPSData.js) buckets: above / green / amber / below.
// Design's zone naming: over / in / close / under.
export const ZONE_COLOR = { above: C.plum, green: C.green, amber: C.orange, below: C.redStrong };
export const ZONE_LEGEND = [
  { status: 'above', label: 'Above target' },
  { status: 'green', label: 'In target' },
  { status: 'amber', label: 'Close' },
  { status: 'below', label: 'Under' },
];

export function rpeColor(val) {
  if (val == null) return C.orange;
  if (val <= 4) return C.teal;
  if (val <= 6) return C.blue;
  if (val <= 8) return C.orange;
  return C.redOrange;
}
